import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';

import { RequestService } from '../services/request.service';
import { AuthenticationService } from '../services/authentication.service';
import { PlansService } from '../services/plans.service';
import { UserService } from '../services/user.service';
import { ProjectsService } from '../services/projects.service';

@Component({
  selector: 'app-activateproduct',
  templateUrl: './activateproduct.component.html',
  styleUrls: ['./activateproduct.component.css']
})
export class ActivateproductComponent implements OnInit {
  pageTitle = 'Activar Producto';

  requestId = '';
  requestEmail = '';
  request: any;
  plan: any;
  expirationDate: Date;
  minDate: Date;
  expirationPlan: Date;
  type: '';
  activity = '';
  commentStatus = '';
  formRef: FormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private requestService: RequestService,
    private authenticationService: AuthenticationService,
    private plansService: PlansService,
    private userService: UserService,
    private projectsService: ProjectsService,
    private router: Router,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
    this.requestId = this.activatedRoute.snapshot.params.pid;
    this.requestEmail = this.activatedRoute.snapshot.params.uid;
    this.activity = this.activatedRoute.snapshot.params.action;
    this.createForm();
    this.authenticationService.getStatus().subscribe(status => {
      this.requestService
        .getRequestsForEmailAndId(this.requestEmail, this.requestId)
        .valueChanges()
        .subscribe(
          data => {
            this.request = data;
            this.plansService
              .getPlanById(this.request['plan'])
              .valueChanges()
              .subscribe(
                data2 => {
                  this.plan = data2;
                  this.type = this.plan.type;
                  if (this.plan.date_expiration) {
                    this.expirationDate = this.plan.date_expiration;
                  } else {
                    this.expirationDate = new Date(
                      this.calcDate(parseInt(this.plan['durationPlan']))
                    );
                  }
                },
                error => {
                  console.log(error);
                }
              );
          },
          error => {
            console.log(error);
          }
        );
    });
  }
  createForm() {
    this.formRef = this.formBuilder.group({
      commentStatus: ['', Validators.required]
    });
  }
  calcDate(days) {
    const newDate = new Date();
    return newDate.setDate(newDate.getDate() + days);
  }
  setActive(request) {
    const expDate = this.expirationDate;
    let state = '';
    let date_expiration;
    switch (this.activity) {
      case 'activate':
        this.formRef.get('commentStatus').clearValidators();
        state = 'activo';
        date_expiration= expDate.toString(),
        this.requestService
          .setExpirationDate(request, date_expiration)
          .then(() => {
          }).catch((e) => {
            console.log(e);
          });
        this.requestService
          .setRequestStatus(request, state)
          .then(() => {
            const action = {
                rid: request.product.pid,
                uid: request.sender,
                date_expiration: expDate.toString(),
                timestamp: Date.now()
              };
            this.projectsService
              .setUserProject(request.product.pid, action)
              .then(() => {
                this.userService
                  .addProject(request, action)
                  .then(() => {
                    alert('Proyecto activado.');
                    this.router.navigate(['/activate']);
                  })
                  .catch(error => {
                    console.log(error);
                  });
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(error => {
            console.log(error);
          });
        break;
      case 'suspend':
        this.deleteOrSuspend('suspendido', 'Proyecto suspendido', request);
        break;
      case 'delete':
        this.deleteOrSuspend('eliminado', 'Proyecto eliminado', request);
        break;
    }
  }
  deleteOrSuspend(state, msg, request) {
    this.formRef.get('commentStatus').setValidators(Validators.required);
    const history = {
      hid: Date.now().toString(),
      comment: this.commentStatus,
      status: state
    };
    this.requestService.setRequestStatus(request, state).then(
      () => {
    }).catch(
      (error) => {
        console.log(error);
      });
    this.requestService.setRequestHistory(request, history).then(
      () => {
        alert(msg);
        this.router.navigate(['/activate']);
    }).catch(
      (error) => {
      console.log(error);
    });
  }
}
